<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Editar vínculo Classe x Receita</h3>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row" v-if="loadedRecipes">
                        <div class="col-md-12">
                            <label for="recipes">Receitas Associados</label>
                            <select name="recipes[]" id="recipes" size="6" v-model="questionClass.recipes" multiple>
                                <option v-for="recipe in recipes" :value="recipe.id">
                                    {{ recipe.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <hr>

                    <a class="btn btn-success" @click="save">Salvar</a>
                    <router-link to="/questionClass" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                questionClass: {
                    id: '',
                    recipes: []
                },
                recipes: [],
                loadedRecipes: false,
                errors: undefined,
            }
        },
        methods: {
            save: function () {
                const api = this.$store.state.api + 'questionClassRecipe';
                const self = this;

                let _recipes = [];
                $('#recipes').find(':selected').each(function(){
                    _recipes.push($(this).val());
                });

                self.$http.post(api, { question_class_id: this.$route.params.id, recipes: _recipes })
                    .then((response) => {
                        this.$message('Sucesso', `Vínculo atualizado com sucesso`, 'success');
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li class="m-t-sm m-b-sm">' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getRecipes: function(){
                const api = this.$store.state.api + 'recipe?paginated=false';
                const self = this;

                return self.$http.get(api);
            },
            getRecipesArray: function(data){
                $.each(data, function(key, value){
                    data[key] = value.recipe_id;
                });

                return data;
            },

            updateSelect: function(){
                $('#recipes').bootstrapDualListbox('refresh',    true);
            }
        },
        mounted: function(){
            const self = this;
            const id   = self.$route.params.id;
            const api  = self.$store.state.api;

            self.getRecipes()
                .then((response) => {
                    self.recipes = response.data.data;

                    self.loadedRecipes = true;
                })
                .then(() => {
                    let recipes = $('#recipes');

                    recipes.bootstrapDualListbox();
                    recipes.ready(function(){
                        recipes.bootstrapDualListbox('refresh', true);
                    });
                })
                .catch((error) => {
                    self.errors = error.response.data.errors;
                    self.$message(null, 'Ocorreu um erro ao buscar as Receitas', 'error');
                });


            self.$http.get(api + 'questionClass/' + id)
                .then((response) => {
                    self.questionClass = response.data;

                    self.questionClass.recipes    = self.getRecipesArray(response.data.question_class_recipes);

                    self.loaded = true;
                })
                .then(() => {
                    self.updateSelect();
                })
        },
        beforeDestroy: function(){
            $('#recipes').bootstrapDualListbox('destroy',   true);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ClassXRecipe/Edit.vue